<template>
  <span>
    <button 
      class="btn btn-secondary" 
      @click="showModal = true"
      :disabled="!hasPermission || schools.length < 2"
    >
      <i class="fa fa-compress"></i>
      Merge Schools
    </button>
    <merge-schools-modal
      v-if="showModal"
      :external-open="showModal"
      :schools="schools"
      :users="users"
      :domain-uuid="domainUuid"
      @merge-success="handleSuccess"
      @update:externalOpen="showModal = $event"
    />
  </span>
</template>

<script>
import MergeSchoolsModal from './MergeSchoolsModal.vue'

export default {
  name: 'MergeSchoolsButton',
  components: {
    MergeSchoolsModal
  },
  props: {
    hasPermission: {
      type: Boolean,
      default: false
    },
    schools: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    domainUuid: {
      type: String,
      required: true
    },
    onSuccess: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    handleSuccess(data) {
      this.showModal = false
      if (this.onSuccess) {
        this.onSuccess(data)
      }
    }
  }
}
</script>
